module.exports = __webpack_public_path__ + "img/other.4ed8788.webp";